'use client';

import { zodResolver } from '@hookform/resolvers/zod';

import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';
import * as z from 'zod';

import { Icons } from 'components/elements/icons';

// バリーデーションルール
const FormSchema = z.object({
  subject: z.string(),

  // firstName: z.string().min(1, {
  //   message: '名字を入力してください。',
  // }),
  // lastName: z.string().min(1, {
  //   message: '名前を入力してください。',
  // }),
  // tel: z.string({ required_error: '電話番号を入力してください' }).max(11, {
  //   message: '電話番号は11桁以内で入力してください',
  // }),
  email: z
    .string()
    .min(1, {
      message: 'メールアドレスを入力してください。',
    })
    .email({ message: 'メールアドレスを正しく入力してください' }),
  message: z.string().min(1, {
    message: 'お問い合わせ内容を入力してください。',
  }),
});

export type FormInput = z.infer<typeof FormSchema>;

export const ContactForm = () => {
  const router = useRouter();
  const {
    register,
    handleSubmit,
    formState: { errors: formatError, isSubmitting },
  } = useForm<FormInput>({ resolver: zodResolver(FormSchema) });

  const onSubmit = async (values: z.infer<typeof FormSchema>) => {
    const response = await fetch('/api/email', {
      method: 'POST',

      body: JSON.stringify(values),
    });

    console.log(response);

    if (response.status === 200) {
      router.push('/contact/thanks');
    } else {
      alert('正常に送信できませんでした');
    }
  };

  const subjects = [
    {
      id: 1,
      name: 'お仕事に関するお問い合わせ',
    },
    // NOTE: お問い合わせ追加したい場合は個々に追加
    // {
    //   id: 2,
    //   name: '〇〇に関するお問い合わせ',
    // },
    {
      id: 3,
      name: 'その他',
    },
  ];

  return (
    <div className='mt-12'>
      <form
        method='post'
        onSubmit={handleSubmit(onSubmit)}
        className='flex flex-col gap-4'
      >
        <div className='flex items-baseline gap-6'>
          <label className='w-24'>Subject:</label>
          <div className='relative flex-1 w-full'>
            <select
              {...register('subject')}
              className='w-full py-2 pl-3 pr-8 text-gray-800 border rounded-md appearance-none xs:text-xs'
            >
              {subjects.map((subject) => {
                return (
                  <option key={subject.id} value={subject.name}>
                    {subject.name}
                  </option>
                );
              })}
            </select>
            <span className='absolute right-2 top-4 xs:top-3'>
              <Icons.arrowDown className='w-3 h-3' />
            </span>
          </div>
          {formatError.subject && (
            <div className='pt-1 pl-1 text-xs text-red-500'>
              {formatError.subject.message}
            </div>
          )}
        </div>
        <div className='flex items-baseline gap-6'>
          <label className='w-24'>Email:</label>
          <input
            type='email'
            {...register('email')}
            className='flex-1 w-full px-3 py-2 text-base border rounded-sm xs:text-xs'
          />
          {formatError.email && (
            <div className='pt-1 pl-1 text-xs text-red-500'>
              {formatError.email.message}
            </div>
          )}
        </div>
        <div className='flex items-baseline gap-6'>
          <label className='w-24'>Message:</label>
          <textarea
            {...register('message')}
            className='flex-1 w-full px-3 py-2 text-base border rounded-sm xs:text-xs'
            rows={8}
          ></textarea>
          {formatError.message && (
            <div className='pt-1 pl-1 text-xs text-red-500'>
              {formatError.message.message}
            </div>
          )}
        </div>
        <button
          className='w-full px-3 py-2 text-base text-white bg-black border rounded-sm'
          type='submit'
          disabled={isSubmitting}
        >
          送信する
        </button>
      </form>
    </div>
  );
};
